export default __webpack_public_path__ + "static/media/sba-report-card_footer.37be10fc.jpg";